import Dialog from "../../../1. Core/Controls/Dialog/Dialog";
import Select from "../../../1. Core/Controls/Select/Select";
import FighterCompareWidgetEditDialog
	from "../../WidgetManager/FighterCompareWidgetEditDialog/FighterCompareWidgetEditDialog";
import FighterCompareStatWidgetEditDialog
	from "../../WidgetManager/FighterCompareStatWidgetEditDialog/FighterCompareStatWidgetEditDialog";
import OnlineTextWidgetEditDialog from "../../WidgetManager/OnlineTextWidgetEditDialog/OnlineTextWidgetEditDialog";
import {IBattle} from "../../types";


export function createWidgetDialog(battle: IBattle, callback: Function = null)
{
	(new Dialog({
		Content: new Select({
			SelectedIndex: 0,
			Items: [
				{
					Content: 'Fighter Compare Widget',
					Value: 'FighterCompareWidgetEditDialog'
				},
				{
					Content: 'Fighter Compare Stat Widget',
					Value: 'FighterCompareStatWidgetEditDialog'
				},
				{
					Content: 'Online text',
					Value: 'OnlineTextWidgetEditDialog'
				}
			]
		}),
		EvOkButtonClick: (dlg: Dialog) =>
		{
			switch (dlg.getContent().getValue())
			{
				case 'FighterCompareWidgetEditDialog':
					(new FighterCompareWidgetEditDialog({
						Battle: battle,
						EvClosed: callback
					})).show()
					break;
				case 'FighterCompareStatWidgetEditDialog':
					(new FighterCompareStatWidgetEditDialog({
						Battle: battle,
						EvClosed: callback
					})).show()
					break;
				case 'OnlineTextWidgetEditDialog':
					(new OnlineTextWidgetEditDialog({
						Battle: battle,
						EvClosed: callback
					})).show()
					break;
			}
		}
	})).show()
}